"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sampleUtil = void 0;
const sampleUtil = () => {
    console.log("Sample Util");
    return "Sample Util";
};
exports.sampleUtil = sampleUtil;
